<div [@routerTransition]>



  <div class="row">

    <div class="modal-body padding-top-0px padding-bottom-0px">



      <ul class="nav nav-tabs nav-tab-service2 margin-top-13px margin-right-15px" id="tabContent">
        <li class="active margin-right-15px margin-left-15px margin-top-auto margin-bottom-auto"><a class="nav-itemerp active" href="#Vendor" data-toggle="tab">OP BILLS</a></li>
        <li class="margin-right-15px margin-top-auto margin-bottom-auto"><a class="nav-itemerp" href="#Material" data-toggle="tab">RX BILLS</a></li>
        
      </ul>

      <div class="tab-content">
        <div class="tab-pane active" id="Vendor">
          <opbilling FromScreen="CommonBilling" marginTop="0"></opbilling>
        </div>
        <div class="tab-pane" id="Material">
          <viewpharmbilling FromScreen="CommonBilling" marginTop="0"></viewpharmbilling>
        </div>
        
      </div>


      </div>
  </div>
      <!--op bills-->

    </div>
